export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14503.f5f825be.jpg";